<template>
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.347656 6L11.6614 6" stroke="currentColor" stroke-width="1.5"/>
    <path d="M6.00391 0.34375L6.00391 11.6575" stroke="currentColor" stroke-width="1.5"/>
  </svg>
</template>

